import React, { useState } from 'react';
import SelectBaseOs from '../shared/imageWizard/SelectBaseOs';
import SelectBaseKind from '../shared/imageWizard/SelectBaseKind';
import SelectBaseImage from '../shared/imageWizard/SelectBaseImage';
import { LAB_STEPS } from '../shared/imageWizard/StepperSidebar';


function MultipleStepBaseImage(props) {
    const [statusForm, setStatusForm] = useState({
        step: 1,
        datacenter: '',
        os: '',
        kindImage: '',
    });

    const { step } = statusForm;

    const prevStep = () => {
        props.setMultipleBaseStepCompleted(false);
        switch (statusForm.step) {
            case 2:
                setStatusForm({
                    ...statusForm,
                    kindImage: "",
                    step: step - 1,
                });
                break;
            case 3:
                setStatusForm({
                    ...statusForm,
                    step: step - 1,
                });
                break;
            default:
                break;
        }
    }

    const handleSelectOs = (myOs) => {
        // Determina il datacenter in base alla versione
        const myDc = props.labVersion === 1 ? 'unimib' : props.labVersion === 2 ? 'unimibv2' : 'default';
        setStatusForm({ ...statusForm, datacenter: myDc, os: myOs, step: step + 1 });
    }

    const handleSelectKindImage = (myKindImage) => {
        setStatusForm({ ...statusForm, kindImage: myKindImage, step: step + 1 });
    }


    switch (step) {
        case 1:
            return <SelectBaseOs
                handleSelectOs={handleSelectOs}
                statusForm={statusForm}
                currentStep={1}
                stepsConfig={LAB_STEPS}
            />
        case 2:
            return <SelectBaseKind
                prevStep={prevStep}
                handleSelectKindImage={handleSelectKindImage}
                statusForm={statusForm}
                currentStep={2}
                stepsConfig={LAB_STEPS}
            />
        case 3:
            return <SelectBaseImage
                prevStep={prevStep}
                setBaseImage={props.setBaseImage}
                baseImage={props.baseImage}
                setIsBookable={props.setIsBookable}
                isBookable={props.isBookable}
                statusForm={statusForm}
                setRepoPkgBundleSelString={props.setRepoPkgBundleSelString}
                setMultipleBaseStepCompleted={props.setMultipleBaseStepCompleted}
                currentStep={3}
                stepsConfig={LAB_STEPS}
            />
        default:
            return null;
    }
}

export default MultipleStepBaseImage;
